import './ExpandableGrid.scss';

import Tile from './Tile';

const ExpandableGrid = ({ id, tiles, logoClickEvent }) => {
    return (
        <section id={id} className="ExpandableGrid">
            <div className="container">
                <h2 className="heading heading--white heading--medium text--center">
                    Selecteer jouw
                    <br />
                    TV-aanbieder
                </h2>
                <div className="container container--small">
                    <div
                        className="grid-container pt3 pb3"
                        style={{ height: `100%` }}
                    >
                        <div className="tiles">
                            {tiles &&
                                tiles.map(tile => {
                                    return (
                                        <Tile
                                            tile={tile}
                                            logoClickEvent={logoClickEvent}
                                            key={`tile-${tile.name}`}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExpandableGrid;
